import React from "react";
import { Questions } from "./Questions";
import Banner from "./Banner";

const FAQs = () => {
    return (
        <div className="content">
            <h3 className="heading">Frequently Asked Questions</h3>
        <Banner>
            {/* <Banner.Header>Frequently Asked Questions</Banner.Header> */}
            {Questions.map((question) => (
                <Banner.Entity key={question.id}>
                    <Banner.Question>{question.question}</Banner.Question>
                    <Banner.Text>{question.answer}</Banner.Text>
                </Banner.Entity>
            ))}
            <h4>
                <br />
                <a href="/contact">Question not on the list? Contact out help desk for further enquiries</a>
            </h4>
            </Banner>
            </div>
    );
}

export default FAQs